<div class="rate">
  <div class="stars">
    @for (icon of mean() | meanArray; track $index) {
      <i [color]="theme()" [iconName]="icon" [size]="size()"></i>
    }
  </div>

  @if (mean() !== undefined && advice() !== undefined) {
    <div class="content">
      {{ mean() }}/5 (
      <a [href]="url()" class="link" rel="noopener noreferrer" target="_blank"> {{ advice() }} avis Google </a>
      )
    </div>
  }
</div>
